import { useEffect } from 'react';
import CopyMagic, { CopyMagicEvents } from 'common/components/CopyMagic';
import type { EventDetailType } from 'common/components/CopyMagic/CopyMagicEvents/CopyMagicEvents.types';

const CONVERSATION_ASSISTANT_OPEN_SELECTOR = 'copy-magic-conversation-assistant--open';

const useOpenCloseListeners = () => {
  useEffect(() => {
    const onOpen = (event: CustomEvent<EventDetailType>) => {
      if (event.detail.generatorName === CopyMagic.GENERATORS.CONVERSATION_ASSISTANT) {
        document.body.classList.add(CONVERSATION_ASSISTANT_OPEN_SELECTOR);
      }
    };
    const onClose = (event: CustomEvent<EventDetailType>) => {
      if (event.detail.generatorName === CopyMagic.GENERATORS.CONVERSATION_ASSISTANT) {
        document.body.classList.remove(CONVERSATION_ASSISTANT_OPEN_SELECTOR);
      }
    };

    CopyMagicEvents.addListener(CopyMagicEvents.EVENT_NAMES.CALLBACK_OPEN, onOpen);
    CopyMagicEvents.addListener(CopyMagicEvents.EVENT_NAMES.CALLBACK_CLOSE, onClose);
    return () => {
      CopyMagicEvents.removeListener(CopyMagicEvents.EVENT_NAMES.CALLBACK_OPEN, onOpen);
      CopyMagicEvents.removeListener(CopyMagicEvents.EVENT_NAMES.CALLBACK_CLOSE, onClose);
    };
  }, []);
};

export default useOpenCloseListeners;
